import React from 'react';
import Header from '../components/layout/Header';
import Team from '../components/sections/Team';
import Footer from '../components/layout/Footer';

const TeamPage = () => {
  return (
    <>
      <Header />
      <Team />
      <Footer />
    </>
  );
};

export default TeamPage;
